var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTamil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tamil",
    transform: "translate(21155 -2786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21155 2786)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_46",
    "data-name": "Union 46",
    d: "M56,35.749H50.922V22.485H44.51v0a20.574,20.574,0,0,1-1.83,3.312,23.014,23.014,0,0,1-6.054,6.19c-3.8,2.586-9.837,3.5-13.853,3.5-.5,0-1-.014-1.475-.041a30.179,30.179,0,0,1-10.373-1.8,26.89,26.89,0,0,1-6.944-3.722A10.45,10.45,0,0,1,.971,26.522a8.236,8.236,0,0,1-.944-3.214,7.97,7.97,0,0,1,.414-3.329H39.647a36.672,36.672,0,0,0-.562-6.153c-.546-3.043-1.749-7.117-4.376-9.248-1.777-1.441-4.379-2.172-7.737-2.172-.583,0-1.158.023-1.716.061a8,8,0,1,1-6.755-.7A19.013,19.013,0,0,1,26.668,0,22.216,22.216,0,0,1,35.74,2,13.643,13.643,0,0,1,41.427,6.7,18.4,18.4,0,0,1,44.1,12.675a25.385,25.385,0,0,1,.783,7.3c.017,0,2.682.2,4.477.2,1.039,0,1.567-.066,1.567-.2V.156h5.084V35.749ZM6.022,27.893c2.618,3.091,7.51,4.792,14.539,5.056.52.019,1.026.029,1.5.029,8.384,0,12.558-2.833,14.583-5.21a10.069,10.069,0,0,0,2.41-5.209H4.127A7.5,7.5,0,0,0,6.022,27.893ZM16.131,10.319a4,4,0,1,0,4-4A4,4,0,0,0,16.131,10.319Z",
    transform: "translate(-21138.131 2812.681)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamil);
export default __webpack_public_path__ + "static/media/Tamil.c40fe9f4.svg";
export { ForwardRef as ReactComponent };